export default __webpack_public_path__ + "static/media/milkshake-wide@3x.a8372fc6.jpg";